// import { useEffect, useState } from "react";
import { usePlay } from "@/providers/play-provider";
import { GameMetadata } from "@/pages/subs/play/common/game-registry";
import { OnlineGameAdapter } from "@/pages/subs/play/common/game-adapter-online";
import { RoomHeader } from "./room-header";

export const GameView = ({ game }: { game: GameMetadata }) => {
  // const { user } = useAuth();
  const { currentRoom } = usePlay();

  if (!currentRoom || !game) {
    return null;
  }

  return (
    <div className="w-full h-full flex flex-col">
      <RoomHeader />
      <div className="flex-1">
        <OnlineGameAdapter game={game} />
      </div>
    </div>
  );
};
